module.exports = __webpack_public_path__ + "img/arc.cdf7f7d4.jpg";